import React from 'react';
export function FuturePacingSection() {
  return <section className="w-full bg-blue-50 py-20 px-4 sm:px-6 lg:px-8" data-id="element-74">
      <div className="max-w-4xl mx-auto text-center" data-id="element-75">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-8" data-id="element-76">
          Vedi te stesso tra 8 settimane: presente, lucido, sicuro.
        </h2>
        <p className="text-xl sm:text-2xl text-gray-700 leading-relaxed max-w-3xl mx-auto" data-id="element-77">
          Ti svegli senza nebbia. Ricordi appuntamenti e dettagli. Conversi con
          calma. Ti sorprendi di quanto sia semplice quando hai una guida
          giorno-per-giorno. Questa è la libertà mentale che costruiremo
          insieme.
        </p>
      </div>
    </section>;
}